import Reveal from "../lib/Reveal";

/* Ícones minimalistas */
function IconCheck({ className = "h-4 w-4" }: { className?: string }) {
  return (
    <svg viewBox="0 0 24 24" className={className} fill="none" stroke="currentColor" strokeWidth="1.8">
      <path d="M20 6 9 17l-5-5" />
    </svg>
  );
}
function IconDot({ className = "h-5 w-5" }: { className?: string }) {
  return (
    <svg viewBox="0 0 24 24" className={className} fill="currentColor">
      <circle cx="12" cy="12" r="6" />
    </svg>
  );
}

/* KPI “chip” */
function StatChip({ label, value }: { label: string; value: string }) {
  return (
    <div className="flex items-baseline gap-2 pr-6">
      <span
        className="inline-grid place-items-center h-6 w-6 rounded-full text-white"
        style={{ background: "linear-gradient(135deg,#FF0064,#ff4d91)" }}
      >
        <IconDot className="h-3 w-3" />
      </span>
      <div>
        <p className="text-[11px] uppercase tracking-widest text-white/60">{label}</p>
        <p className="-mt-0.5 text-xl font-extrabold">{value}</p>
      </div>
    </div>
  );
}

export default function AboutBanner() {
  return (
    <section
      id="sobre"
      className="
        relative isolate overflow-hidden bg-[#0b0b0c]
        /* padding levemente maior para acomodar o feather */
        pt-16 md:pt-22 pb-16 md:pb-22
      "
    >
      {/* FEATHERS: transições suaves no topo e base */}
      <div
        aria-hidden
        className="pointer-events-none absolute inset-x-0 -top-6 h-10
                   bg-gradient-to-b from-transparent via-[#0b0b0c]/50 to-[#0b0b0c]"
      />
      <div
        aria-hidden
        className="pointer-events-none absolute inset-x-0 -bottom-6 h-10
                   bg-gradient-to-t from-transparent via-[#0b0b0c]/50 to-[#0b0b0c]"
      />

      {/* mesh / nuances rosa (sem imagem) */}
      <div className="pointer-events-none absolute inset-0">
        <div
          className="absolute -left-24 top-0 h-[34rem] w-[34rem] rounded-full blur-3xl opacity-[.22]"
          style={{ background: "radial-gradient(50% 50% at 50% 50%, rgba(255,0,100,.55) 0%, rgba(255,0,100,0) 60%)" }}
        />
        <div
          className="absolute right-[-8rem] bottom-[-10rem] h-[42rem] w-[42rem] rounded-full blur-3xl opacity-[.18]"
          style={{ background: "radial-gradient(50% 50% at 50% 50%, rgba(255,77,145,.45) 0%, rgba(255,77,145,0) 60%)" }}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-black/20 to-black/40" />
      </div>

      <div className="relative mx-auto max-w-7xl px-4">
        <Reveal>
          {/* Cabeçalho enxuto + KPIs em linha */}
          <header className="max-w-4xl">
            <span className="brand-badge inline-flex items-center px-3 h-7 text-xs font-semibold">by LOViZ</span>
            <h2 className="mt-4 text-3xl md:text-5xl font-extrabold">Por que a LOViZ?</h2>

            <p className="mt-3 text-white/85 leading-relaxed">
              Do projeto à operação diária, cuidamos de tudo: desenho da rede, ativação por unidade e suporte direto
              com SLA — sem burocracia e sem custos de implantação para o condomínio.
            </p>

            <div className="mt-6 flex flex-wrap gap-y-4">
              <StatChip label="Condomínios atendidos" value="100+" />
              <StatChip label="CSAT (satisfação)" value="98%" />
              <StatChip label="Ativação média" value="48h" />
              <StatChip label="Disponibilidade" value="99,9%" />
            </div>
          </header>

          {/* REMOVIDO: linha divisória rígida (h-px) */}
          {/* <div className="my-8 h-px w-full bg-gradient-to-r from-transparent via-white/10 to-transparent" /> */}

          {/* Pilares */}
          <div className="mt-10 grid gap-6 md:grid-cols-3">
            <Pillar
              title="Projeto & Rede"
              items={[
                "Levantamento técnico gratuito",
                "Projeto óptico dedicado ao prédio",
                "Racks e documentação padronizados",
              ]}
            />
            <Pillar
              title="Ativação & Operação"
              items={[
                "Ativação por unidade, sem obras",
                "Monitoramento pró-ativo 24/7",
                "Atendimento direto com SLA",
              ]}
            />
            <Pillar
              title="Contrato & Gestão"
              items={[
                "Sem CAPEX para o condomínio",
                "Faturamento por unidade",
                "Relatórios de qualidade e uso",
              ]}
            />
          </div>
        </Reveal>
      </div>
    </section>
  );
}

/* Coluna de pilares */
function Pillar({ title, items }: { title: string; items: string[] }) {
  return (
    <div className="min-h-[12rem]">
      <h3 className="text-xl font-bold">{title}</h3>
      <ul className="mt-3 grid gap-2.5 text-sm text-white/90">
        {items.map((t, i) => (
          <li key={i} className="flex items-start gap-2">
            <span className="mt-0.5 h-6 w-6 grid place-items-center rounded-full bg-white/10">
              <IconCheck />
            </span>
            <span>{t}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
